import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import { GlobalStyle } from '../../global/global';
import { Box, Text } from '@chakra-ui/react';
import TilesSection from '../../sections/TilesSection/TilesSection';
import PromoBar from '../../sections/PromoBar/PromoBar';
import ContactSection from '../../sections/ContactSection/ContactSection';
import PlainSection from '../../sections/PlainSection/PlainSection';

interface Props {}

const image = {
    url: 'https://www.idosell.com/panel/file-gate.php?id=324661&ext=.jpg',
    alt: 'Zdjęcie wyróżniające w hero - strona POS',
};

export default function PosPage(props: Props) {
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <HeroSection
                title="Sprzedaż stacjonarna i sklep internetowy w jednym miejscu"
                subTitle="Zintegruj swój sklep internetowy i stacjonarny w jednym nowoczesnym systemie kasowym POS. Zwiększ sprzedaż i swobodnie zarządzaj zamówieniami z obu kanałów"
                image={image}
                type="landing"
            />
            <div className="homepage containerIdosellPages">
                <Box
                    py={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    display={'flex'}
                    flexDirection={{ base: 'column', xl: 'row' }}
                    gap={{
                        base: 6,
                        md: 12,
                    }}
                    position={'relative'}
                >
                    <TilesSection
                        title={'Dlaczego warto wybrać nasz system POS?'}
                        // layout="2x3"
                        tiles={[
                            {
                                title: 'Pełna integracja z e-sklepem',
                                content:
                                    'System Kasowy POS od IdoSell to pełna integracja sklepu stacjonarnego z internetowym oraz spójność cen w sprzedaży online i offline.',
                            },
                            {
                                title: 'Lepsza obsługa klienta',
                                content:
                                    'Personalizuj oferty i obsługę twoich klientów dzięki zaawansowanym narzędziom. Dodatkowo, dzięki automatycznej aktualizacji, twoje stany magazynowe będą zawsze zsynchronizowane.',
                            },
                            {
                                title: 'Spójne promocje i oferty specjalne',
                                content:
                                    'POS gwarantuje pełną obsługę nowego modułu promocji IdoSell, ofert specjalnych oraz towarów gratisowych.',
                            },
                        ]}
                    />
                </Box>
                <Box
                    py={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    display={'flex'}
                    flexDirection={{ base: 'column', xl: 'row' }}
                    gap={{
                        base: 6,
                        md: 12,
                    }}
                    position={'relative'}
                >
                    <PlainSection
                        layout="2/3"
                        title="Czym jest system POS?"
                        imageSide="left"
                        image={{
                            url: 'https://www.idosell.com/panel/file-gate.php?id=324662&ext=.jpg',
                            alt: 'Zdjęcie wyróżniające w hero - strona POS',
                        }}
                        text={
                            <>
                                <Text mb={'1rem'}>
                                    System POS od IdoSell to nowoczesne rozwiązanie kasowe, które
                                    umożliwia prowadzenie sprzedaży zarówno w sklepach
                                    stacjonarnych, jak i online. Nasz system POS wyróżnia się pełną
                                    integracją kanałów sprzedaży, czyli omnichannel. Oznacza to, że
                                    wszystkie transakcje są automatycznie synchronizowane między
                                    sklepem stacjonarnym a internetowym.
                                </Text>
                                <Text>
                                    Dzięki omnichannel twoi klienci mogą robić zakupy w sposób
                                    wygodny dla nich, a ty możesz zarządzać swoim biznesem w jednym
                                    miejscu, oszczędzając czas i zwiększając efektywność.
                                </Text>
                            </>
                        }
                    ></PlainSection>
                </Box>
                <PromoBar
                    eyebrow="Gotowy na rozpoczęcie?"
                    title="Skorzystaj z naszego systemu POS za darmo przez 30 dni!"
                    version="green"
                    buttonText="Rozpocznij teraz"
                    href="https://pomoc.idosell.com/sprzedaz/idosell-pos/funkcje-i-mozliwosci-pos"
                />
                <Box
                    py={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    display={'flex'}
                    flexDirection={{ base: 'column', xl: 'row' }}
                    gap={{
                        base: 6,
                        md: 12,
                    }}
                    position={'relative'}
                >
                    <TilesSection
                        title={
                            'System kasowy POS od IdoSell - pełna integracja sprzedaży online i offline'
                        }
                        layoutDesktop="4-in-row"
                        tiles={[
                            {
                                title: 'Automatyczne aktualizacje stanów magazynowych',
                            },
                            {
                                title: 'Zaawansowane narzędzia analityczne ',
                            },
                            {
                                title: 'Obsługa terminali płatniczych i  paragonów fiskalnych',
                            },
                            {
                                title: 'Możliwość stosowania rabatów, promocji i ofert specjalnych z  e-sklepu',
                            },
                            {
                                title: 'Obsługa odbiorów osobistych (click & collect) oraz zwrotów towarów',
                            },
                            {
                                title: 'Raporty kasowe, lista sprzedanych towarów + wykaz wystawionych dokumentów',
                            },
                            {
                                title: 'Zarządzanie bonami, kartami podarunkowymi i stałego klienta',
                            },
                            {
                                title: 'Towary gratisowe',
                            },
                        ]}
                    />
                </Box>
                <ContactSection pb={1} mb={14} />
            </div>
        </ThemeProvider>
    );
}
